<label
  class="label"
  [class.checked]="inputCheck.checked"
  [class.left-side]="labelOnLeftSide"
  [class.error]="controlDir?.invalid && parentFormGroup.submitted"
  [class.disabled]="isDisabled"
>
  <div class="mark">
    <gl-icon class="markOn" [name]="'mark'"></gl-icon>
  </div>
  <input class="input" type="checkbox" [name]="name" #inputCheck />
  <span class="text">
    <ng-content></ng-content>
  </span>
</label>
